const FreeCourseSD = (goalData, freeFeedOfGoal) => {
  if (!freeFeedOfGoal) return null;
  const courseList = {
    '@context': 'http://schema.org',
    '@type': 'ItemList',
    url: null,
    numberOfItems: '45',
    itemListElement: []
  };
  let pos = 0;
  const { results } = freeFeedOfGoal;
  results.forEach((feedBlock) => {
    const feedType = feedBlock.extraBlockinfo?.id?.toLowerCase();
    if (
      feedType === 'courses' ||
      feedType === 'course' ||
      feedType === 'courses_big' ||
      feedType === 'my_classes' ||
      feedType === 'programme' ||
      feedType === 'popular_courses'
    ) {
      const { courses } = feedBlock;

      courses.forEach((course) => {
        const {
          permalink,
          name,
          description,
          thumbnail,
          uid,
          authors,
          forPlus,
          language
        } = course;
        if (!courseList.url) courseList.url = permalink;
        const author = authors[0];

        const {
          name: authName,
          thumbnail: authThumbnail,
          description: bio
        } = author;

        const courseObject = {
          '@type': 'Course',
          '@id': permalink,
          position: pos,
          name,
          url: permalink,
          about: description,
          description,
          thumbnailUrl: thumbnail,
          courseCode: uid,
          accessMode: ['auditory', 'visual'],
          author: {
            '@type': 'Person',
            '@id': uid,
            name: authName,
            image: authThumbnail,
            description: bio,
            jobTitle: 'Educator'
          },

          isAccessibleForFree: forPlus ? 'False' : 'True',
          inLanguage: language,
          provider: {
            '@type': 'Organization',
            name: 'Unacademy',
            sameAs: 'https://unacademy.com/'
          }
        };

        courseList.itemListElement.push(courseObject);
        pos += 1;
      });
    }
    // return courseList;
  });
  courseList.numberOfItems = courseList.itemListElement.length;

  return courseList;
};

export default FreeCourseSD;
